
import BaseActionButton from '@/components/common/BaseActionButton.vue'
import ImageUploader from '@/components/common/ImageUploader.vue'
import PhoneCallButton from '@/components/common/PhoneCallButton.vue'

export default {
  name: 'DeliveryConfirmDrawer',
  components: { BaseActionButton, ImageUploader, PhoneCallButton },
  props: {
    value: { type: Boolean, default: false },
    order: { type: Object, default: null },
    // 角色只决定 API 前缀,不决定任何视觉
    role: {
      type: String,
      default: 'courier',
      validator: v => ['admin', 'operator', 'courier'].includes(v)
    }
  },
  data () {
    return {
      photo: '',
      remark: '',
      submitting: false
    }
  },
  watch: {
    // 每次打开重置表单(沿用旧抽屉行为:预填已有送达照片,备注清空)
    value (open) {
      if (open) {
        this.photo = (this.order && this.order.delivery_photo) || ''
        this.remark = ''
        this.submitting = false
      }
    }
  },
  methods: {
    close () {
      if (this.submitting) return
      this.$emit('input', false)
    },
    onPhotoChange (url) {
      this.photo = url
    },
    async submit () {
      if (!this.order || this.submitting) return
      this.submitting = true
      try {
        // admin/operator 复用共享 /mobile-delivery；courier 保持原 courier-mobile(本阶段不合并前缀)
        const prefix = this.role === 'courier' ? '/courier-mobile' : '/mobile-delivery'
        await this.axios.post(`${prefix}/orders/${this.order.id}/deliver`, {
          photo: this.photo || null,
          remark: this.remark || null,
          location: null
        })
        this.$q.notify({ type: 'positive', message: '已标记送达' })
        this.$emit('input', false)
        this.$emit('success', this.order)
      } catch (err) {
        // 失败保留现场(照片/备注不清空),可直接重试
        this.$q.notify({ type: 'negative', message: (err.response && err.response.data && err.response.data.message) || '操作失败' })
        this.submitting = false
      }
    }
  }
}
